import { Skeleton } from '@/components/ui/skeleton';

/**
 * Full-page loading skeleton shown as the Suspense fallback
 * while lazy-loaded route components are being fetched.
 */
const PageLoadingSkeleton = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-50 to-white">
      {/* Top nav bar skeleton */}
      <div className="h-16 border-b border-slate-200 px-6 flex items-center gap-4">
        <Skeleton className="h-8 w-8 rounded-full" />
        <Skeleton className="h-4 w-32" />
        <div className="flex-1" />
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-8 w-8 rounded-full" />
      </div>

      {/* Page content skeleton */}
      <div className="flex-1 max-w-5xl w-full mx-auto px-6 py-8 space-y-6">
        {/* Page title */}
        <Skeleton className="h-8 w-64" />

        {/* Subtitle / breadcrumb */}
        <Skeleton className="h-4 w-48" />

        {/* Content blocks */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4">
          <Skeleton className="h-28 rounded-xl" />
          <Skeleton className="h-28 rounded-xl" />
          <Skeleton className="h-28 rounded-xl" />
        </div>

        {/* Main content area */}
        <div className="space-y-3 pt-4">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-4/6" />
        </div>

        <div className="space-y-3 pt-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      </div>
    </div>
  );
};

export default PageLoadingSkeleton;
